import { Component, Inject, Input } from '@angular/core';

import { NavigationLink } from '@cigna/chcp/shared/util';
@Component({
  selector: 'cigna-header-user-util',
  templateUrl: './header-user-util.component.html',
  styleUrls: ['./header-user-util.component.scss'],
})
export class HeaderUserUtilComponent {
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() userid = '';
  @Input() profileLinks: NavigationLink[] = [];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() impersonator = false;
  @Input() hasMessageCenterFunction = false;
  @Input() isOhpUser = false;

  constructor(@Inject('inboxUrl') public inboxUrl: string) {}
}
